import {MvsCrudService} from "../../../../../core/shared/service/crud/mvs-crud.service";
import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {MvsCoreService} from "../../../../../core/shared/service/mvs-core.service";
import {ObjectRequestList} from "../../../../../core/shared/dto/object/request/object-request-list";
import {DcPageTypeDto} from "../../../model/dto/entity/dc-page-type.dto";
import {DtoList} from "../../../../../core/shared/dto/dto.list";
import {ObjectTypeDto} from "../../../../../core/cc/model/dto/entity/object-type.dto";
import {ObjectTypeService} from "../../../../../core/cc/service/api/object-type.service";
import {DcPageService} from "../../../service/dc-page.service";
import {DcPageDto} from "../../../model/dto/entity/dc-page.dto";
import {ModuleDto} from "../../../../../core/cc/model/dto/entity/module.dto";
import {ModuleService} from "../../../../../core/cc/service/api/module.service";
import {DtoDetail} from "../../../../../core/shared/dto/dto.detail";
import {
    MvsSearchEntityEvent
} from "../../../../../core/shared/components/mvs-entity-search/mvs-entity-search.component";
import {ObjectBaseComponent} from "../../../../../core/shared/object/mvs-object-base/object-base.component";
import {MvsMessageService} from "../../../../../core/shared/service/message/mvs-message.service";
import {ConfirmationService} from "primeng/api";
import {ObserverService} from "../../../../../core/shared/object/service/observer.service";
import {
    ObjectChangeInformation,
    ObjectChangeInformationActionEnum
} from "../../../../../core/shared/logic/object-change-information";

@Component({
    selector: 'dc-page-create',
    templateUrl: './dc-page-create.component.html',
    standalone: false
})
export class DcPageCreateComponent extends ObjectBaseComponent implements OnInit, OnChanges, OnDestroy {

    pageTypeService: MvsCrudService;
    pageTypesDtoList: DtoList<DcPageTypeDto>;
    objectTypesDtoList: DtoList<ObjectTypeDto>;
    pageDtoList: DtoList<DcPageDto>;
    moduleDtoList: DtoList<ModuleDto>;

    objectIdDtoList: DtoList<DtoDetail>;

    selectedPageType: DcPageTypeDto;
    selectedObjectType: ObjectTypeDto;
    selectedObjectId: number;
    selectedDcPageId: number;
    pageTitle: string;
    priority: number;
    selectedObjectTypeName: string;
    parentPageId: number;
    parentPageDto: DcPageDto;

    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized

    constructor(protected coreService: MvsCoreService,
                protected messageService: MvsMessageService,
                protected confirmationService: ConfirmationService,
                protected observerService: ObserverService,
                protected objectTypeService: ObjectTypeService,
                protected pageService: DcPageService,
                protected moduleService: ModuleService) {
        super(coreService, messageService, confirmationService, observerService);

        this.pageTypeService = this.coreService.getCrudService("dc.DcPageType");
    }

    override ngOnInit(): void {
        super.ngOnInit();
        this.initComponent();

    }

    /**
     * Initialize Component.
     */
    initComponent() {

        this.handleImportObjectContext();
        this.getAllPageTypes();
        this.getAllDcPages();
        this.refreshComponent();
    }

    handleImportObjectContext() {

        if (!this.importObjectContext) {
            return;
        }

        const parentPage = this.importObjectContext.getEntry('dc.DcPage');

        if (!parentPage) {
            return;
        }

        this.parentPageId = parentPage.id;
        this.getParentPageInfo(this.parentPageId);

    }

    getParentPageInfo(pageId: number) {
        this.pageService.get(pageId).subscribe((res: DcPageDto) => {
            this.parentPageDto = res;
        }, error => {

        });
    }

    getAllPageTypes() {
        const request = ObjectRequestList.createSimple(null);
        this.pageTypeService.list(request).subscribe(pageTypes => {
            this.pageTypesDtoList = pageTypes;
            this.initialized = true;
        });
    }

    onSelectPageType() {
        if (!this.selectedPageType.linkedObjectTypeDtoId) {

            this.getAllObjectTypes();
            this.selectedObjectTypeName = null;
            this.objectIdDtoList = null;
        }

        if (this.selectedPageType.linkedObjectTypeDtoId) {
            this.selectedObjectTypeName = this.selectedPageType.linkedObjectTypeDtoName;
            this.getAllModules();
        }

    }

    onSelectObjectType() {
        this.selectedObjectTypeName = this.selectedObjectType.alias;
    }

    getAllObjectTypes() {

        if (this.busy) {
            return;
        }

        this.busy = true;

        if (this.objectTypesDtoList && this.objectTypesDtoList.entries?.length) {
            return;
        }

        const request = ObjectRequestList.createSimple(null);

        this.objectTypeService.list(request).subscribe(objectTypes => {
            this.busy = false;
            this.objectTypesDtoList = objectTypes;
        });
    }

    getAllDcPages() {
        if (this.pageDtoList && this.pageDtoList.entries?.length) {
            return;
        }

        const request = ObjectRequestList.createSimple(null);

        this.pageService.list(request).subscribe(res => {
            this.pageDtoList = res;
        });
    }

    getAllModules() {

        if (this.moduleDtoList && this.moduleDtoList.entries?.length) {
            return;
        }

        const request = ObjectRequestList.createSimple(null);

        this.moduleService.list(request).subscribe(res => {
            this.moduleDtoList = res;
            this.objectIdDtoList = this.moduleDtoList;
        });
    }

    handleOnCreateDcPage() {

        if (this.selectedPageType) {
            this.createDcPageFromPageType();
        } else {
            // normal create without page type
            this.createDcPageNormal();
        }
    }

    createDcPageFromPageType() {

        if (this.busy) {
            return;
        }

        this.busy = true;

        const pageId = this.getParentPageId();

        this.pageService.createPageContent(
            this.selectedPageType?.id,
            pageId,
            this.pageTitle,
            this.priority,
            this.selectedObjectType?.id,
            this.selectedObjectId
        ).subscribe(page => {
                this.emitEvent(page);
                this.busy = false;
                this.showSuccessMessage();

            }, error => {
                this.busy = false;
            }
        );

    }

    showSuccessMessage() {
        this.messageService.showSuccessMessage('', 'Page created successfully.');
    }

    emitEvent(dto: DtoDetail) {
        const object = new ObjectChangeInformation();
        object.objectType = 'dc.DcPage';
        object.action = ObjectChangeInformationActionEnum.created;
        object.after = dto;

        this.onChangedObject.emit(object);

    }

    createDcPageNormal() {
        if (this.busy) {
            return;
        }

        let level = this.parentPageDto?.level;

        if (!level) {
            level = 0;
        }

        this.busy = true;
        const dto = new DcPageDto();
        dto.parentDtoId = this.getParentPageId();
        dto.title = this.pageTitle;
        dto.level = level + 1;

        this.pageService.create(dto).subscribe(page => {
                this.emitEvent(page);
                this.busy = false;
                this.showSuccessMessage();

            }, error => {
                this.busy = false;
            }
        );
    }

    getParentPageId() {
        let pageId = null;

        if (this.parentPageId) {
            pageId = this.parentPageId;
        } else {
            pageId = this.selectedDcPageId;
        }

        return pageId;
    }

    handleSelectPage(event: MvsSearchEntityEvent) {
        if (event) {
            this.selectedDcPageId = event.objectId;
            this.getParentPageInfo(this.selectedDcPageId);
        }
    }

    handleSelectObjectId(event: MvsSearchEntityEvent) {
        if (event) {
            this.selectedObjectId = event.objectId;
        }
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.initialized = true;
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
